class SharedStorageReduxReducersGenerator {
    constructor(storageInitValue) {
        this.storageInitValue = storageInitValue;
    }

    generate = () => {
        let reducers = {};
        // const _generateNestedKeys = (
        // storageInitValue,
        // curStorageInitValue = storageInitValue,
        // depth = 0,
        // parentKeyList = []
        // ) => {
        // Object.keys(curStorageInitValue).forEach((initKey) => {
        //     // 
        //     // if (depth === 0) {
        //     const actionType = `set_${initKey}`;
        //     reducers[initKey] = (state = curStorageInitValue[initKey], action) => {
        //         if (action.type === actionType) {
        //             return action.payload;
        //         }
        //         return state;
        //     }
        // })



        // all the commented code is from trying to allow nested storage keys
        // its not worth it right now



                // // 
                // if (depth > 0) {
                //     const actionType = `set_${parentKeyList.join(".")}.${initKey}`;
                //     reducers[initKey] = (state = curStorageInitValue[initKey], action) => {
                //         if (action.type === actionType) {
                            // let newState = { 
                            //     [initKey]: action.payload 
                            // };
                            // const reverseParentKeyList = [ ...parentKeyList ].reverse();                            
                            // reverseParentKeyList.forEach((parentKey) => {
                            //     newState = {
                            //         [parentKey]: {
                            //             // spread the parent key's value

                            //             ...newState
                            //         }
                            //     }
                            // })
                            // let newState = {};
                            // parentKeyList.forEach((parentKey, index) => {
                            //     const curParentKeyList = parentKeyList.slice(0, index + 1);

                            //     storageInitValue[parentKey]
                            //     if (index === parentKeyList.length - 1) {

                            //     }
                            // })
                            // return action.payload;

        //                     const newState = new Proxy(curStorageInitValue, {
        //                         set(target, prop, value) {
        //                             target[prop] = value;
        //                             return true;
        //                         },
        //                         get(target, prop) {
        //                             if (typeof target[prop] === "object" && target[prop]) {
        //                                 return new Proxy(target[prop], this);
        //                             } else {
        //                                 return target[prop];
        //                             }
        //                         },
        //                     });
        //                 }
        //                 return state;
        //             }
        //         }

        //         if (typeof curStorageInitValue[initKey] === "object" && curStorageInitValue[initKey]) {
        //             const newDepth = depth + 1;
        //             const newParentKeyList = parentKeyList.push(initKey);
        //             _generateNestedKeys(
        //                 storageInitValue,
        //                 curStorageInitValue[initKey],
        //                 newDepth,
        //                 newParentKeyList
        //             );
        //         }
        //     })
        // }
        // _generateNestedKeys(this.storageInitValue);
        Object.keys(this.storageInitValue).forEach((initKey => {
            reducers[initKey] = (state=this.storageInitValue[initKey], action) => {
                if (action.type === `set_${initKey}`) {
                    return action.payload;
                }
                return state;
            }
        }));
        return reducers;
    }
}

export default SharedStorageReduxReducersGenerator;